import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DataManagerService} from '../../data/services/DataManager/data-manager.service';
import {AppConstants} from '../../shared/constants/app-constants';

@Component({
    selector: 'app-request-details',
    templateUrl: './request-details.component.html',
    styleUrls: ['./request-details.component.css'],
    standalone: false
})
export class RequestDetailsComponent implements OnInit {

  // PDT-32072 (AC-08) — merchant response to a pended bank account change request.
  static readonly MAX_FILES = 10;
  static readonly MAX_FILE_SIZE = 20 * 1024 * 1024; // mirrors the API's 20MB per-file rule
  responseNote = '';
  responseFiles: File[] = [];
  submitting = false;
  responseError: string = null;

  constructor(private dialog: MatDialogRef<RequestDetailsComponent>,
              private dataManager: DataManagerService,
              @Inject(MAT_DIALOG_DATA) public data: {
                id: string,
                status: string,
                requested_at: string,
                completed_at: string | null,
                reason: string,
                note: string,
                upload_link: string,
                can_respond: boolean,
                pend_note: string | null,
                pend_documents: string[]
              }) {
  }
  closeAction() {
    this.dialog.close('cancel');
  }

  ngOnInit(): void {
  }

  onFilesSelected(event: any) {
    const selected: File[] = Array.from(event.target.files || []);
    this.responseError = null;

    for (const file of selected) {
      if (this.responseFiles.length >= RequestDetailsComponent.MAX_FILES) {
        this.responseError = `You can attach up to ${RequestDetailsComponent.MAX_FILES} files.`;
        break;
      }
      if (file.size > RequestDetailsComponent.MAX_FILE_SIZE) {
        this.responseError = `${file.name} exceeds the 20MB per-file limit.`;
        continue;
      }
      this.responseFiles.push(file);
    }

    event.target.value = null;
  }

  removeFile(index: number) {
    this.responseFiles.splice(index, 1);
  }

  canSubmit(): boolean {
    return !this.submitting && (this.responseFiles.length > 0 || this.responseNote.trim() !== '');
  }

  submitResponse() {
    if (!this.canSubmit()) {
      return;
    }

    this.submitting = true;
    this.responseError = null;

    const payload = new FormData();
    payload.append('id', this.data.id);
    if (this.responseNote.trim() !== '') {
      payload.append('note', this.responseNote.trim());
    }
    this.responseFiles.forEach((file) => payload.append('files[]', file, file.name));

    this.dataManager.fileUpload(AppConstants.BASE_URL + '/merchant_bank_accounts/pend-response', payload, 0)
      .subscribe(
        () => {
          this.submitting = false;
          // The list component refreshes on this result so the row shows the new status.
          this.dialog.close('responded');
        },
        (err) => {
          this.submitting = false;
          this.responseError = err?.error?.message || 'Failed to submit your response. Please try again.';
        }
      );
  }

}
